module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-CondIt.cbe70a7.eot";